import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'oauth-dialog',
  templateUrl: './oauth-dialog.component.html',
  styleUrls: ['./oauth-dialog.component.css'],
})
export class OauthDialogComponent implements OnInit {
  constructor(
    public matDialogRef: MatDialogRef<OauthDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: any
  ) {}

  ngOnInit(): void {}

  buttonOne() {
    this.matDialogRef.close(0);
  }

  buttonTwo() {
    this.matDialogRef.close(1);
  }
}
